var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 503,
    viewBox: "0 0 426 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.644 397.593H31.429V61.671H265.58V86.801H297.052V54.811C297.073 24.677 272.331 0 242.218 0H54.833C24.677 0 0 24.677 0 54.811V447.831C0 478.009 24.677 502.664 54.833 502.664H242.218C272.331 502.664 297.073 478.009 297.073 447.831V397.01H265.644V397.593ZM148.493 475.226C134.601 475.226 123.385 463.988 123.385 450.118C123.385 436.205 134.602 424.988 148.493 424.988C162.406 424.988 173.645 436.226 173.645 450.118C173.645 463.988 162.407 475.226 148.493 475.226Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.519 95.386H58.2627V138.226H128.519V95.386Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.519 205.073H58.2627V247.913H128.519V205.073Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.519 319.873H58.2627V362.691H128.519V319.873Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166 322.13C166 335.674 170.759 347.206 180.277 356.723C189.794 366.241 201.326 371 214.87 371H377.404C390.766 371 402.206 366.241 411.723 356.723C421.241 347.206 426 335.674 426 322.13V251.845L393.603 279.025V322.13C393.603 326.706 392.047 330.549 388.936 333.661C385.824 336.773 381.98 338.42 377.404 338.603H214.87C210.294 338.603 206.451 336.956 203.339 333.661C200.227 330.366 198.672 326.523 198.672 322.13V159.596C198.672 155.203 200.227 151.359 203.339 148.064C206.451 144.77 210.294 143.214 214.87 143.397H296.137V111H214.87C201.326 111 189.794 115.759 180.277 125.277C170.759 134.794 166 146.234 166 159.596V322.13ZM214.87 273.534C214.87 289.275 217.982 304.376 224.205 318.835C227.133 301.996 233.54 286.713 243.423 272.985C253.307 259.258 265.571 248.184 280.213 239.765C294.856 231.345 310.963 226.586 328.534 225.488V273.534L426 192.267L328.534 111V159.596C313.159 159.596 298.425 162.616 284.332 168.656C270.238 174.696 258.158 182.841 248.091 193.091C238.024 203.341 229.879 215.421 223.656 229.332C217.433 243.242 214.504 257.976 214.87 273.534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharin);
export default __webpack_public_path__ + "static/media/Sharin.e57969eefa89c1c8d18a885ddc7b3c28.svg";
export { ForwardRef as ReactComponent };